import { DashboardStatus } from '../../../../domain';

export function showIntegrationRequirementText(status: DashboardStatus) {
    // show requirement text unless all mandatory integrations has been connected
    return status.kind !== 'no-data-sharing' || (status.kind === 'no-data-sharing' && !status.connected);
}
